import React, { useContext, useEffect } from 'react';
import RingilSidebar from '@components/ringil3/Sidebar/RingilSidebar';
import Label from '@components/obsolete/Form/Label/Label';
import { ApiContext } from '@api/api';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from '@components/RingilComponents/SafeDropdown';
import { MultiSelect } from 'primereact/multiselect';
import useResponsiblePersons from '@hooks/responsible-persons/responsible-persons';
import { EditTemplateInternalInformation } from '@api/ringil-api.v2';
import useTranslation from '@hooks/i18n/useTranslation.tsx';

interface ComponentProps {
  visible: boolean;
  onHide: () => void;
  templateId: string;
  onComplete: () => void;
}

const initialValues: EditTemplateInternalInformation = {
  subscribers: [],
  responsiblePersonId: null,
  internalNote: '',
};

const validationSchema = yup.object().shape({});

const EditInternalInformationSidebar: React.FC<ComponentProps> = ({ visible, onHide, templateId, onComplete }) => {
  const { tr } = useTranslation();
  const { cuUpdateEditInternalInformation, cuGetEditInternalInformation } = useContext(ApiContext);
  const formik = useFormik<EditTemplateInternalInformation>({
    initialValues,
    validationSchema,
    onSubmit: (v: any) => save(v),
  });
  const responsiblePersons = useResponsiblePersons();

  const save = (v: EditTemplateInternalInformation) => {
    cuUpdateEditInternalInformation(templateId, v, () => {
      onComplete();
    });
  };

  useEffect(() => {
    if (visible) {
      cuGetEditInternalInformation(templateId, d => {
        formik.setFieldValue(
          'subscribers',
          d.subscribers.map(t => t.userId),
        );
        formik.setFieldValue('responsiblePersonId', d.responsiblePerson?.userId);
        formik.setFieldValue('internalNote', d.internalNote);
      });
    }
  }, [visible]);

  return (
    <>
      {/*
        // @ts-ignore*/}
      <RingilSidebar
        visible={visible}
        size={'md'}
        heading={tr(`EditInternalInformationSidebar.editInternalInformation`, `Edit internal information`)}
        // The save button was type="submit" inside the form; the wrapper's footer sits outside it,
        // so it calls formik directly instead.
        onContinue={() => formik.handleSubmit()}
        onBack={() => onHide()}
        continueLabel={tr('labelSave')}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="p-field">
            <Label title={tr(`EditInternalInformationSidebar.responsiblePerson`, `Responsible person`)} />
            <div className="p-inputgroup">
              <Dropdown
                options={responsiblePersons}
                optionValue={'id'}
                optionLabel={'name'}
                value={formik.values.responsiblePersonId}
                dataKey={'id'}
                onChange={e => formik.setFieldValue('responsiblePersonId', e.target.value)}
              />
            </div>
          </div>
          <div className="p-field">
            <Label title={tr(`EditInternalInformationSidebar.subscribers`, `Subscribers`)} />
            <div className="p-inputgroup">
              <MultiSelect
                options={responsiblePersons}
                optionValue={'id'}
                optionLabel={'name'}
                value={formik.values.subscribers}
                dataKey={'id'}
                onChange={e => formik.setFieldValue('subscribers', e.target.value)}
              />
            </div>
          </div>
          <div className="p-field">
            <Label title={tr(`EditInternalInformationSidebar.internalNote`, `Internal note`)} />
            <div className="p-inputgroup">
              <InputTextarea value={formik.values.internalNote} onChange={formik.handleChange} name={'internalNote'} />
            </div>
          </div>
        </form>
      </RingilSidebar>
    </>
  );
};

export default EditInternalInformationSidebar;
